import { FC, useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders its children into a dedicated `#modal` DOM node appended to `<body>`.
 * Creates the root element on first use if it does not already exist.
 *
 * Use this as the base layer for all modal and overlay components to ensure
 * they render outside the main React tree and sit above other content.
 */
const Portal: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
	let modalRoot = document.getElementById('modal');

	if (!modalRoot) {
		modalRoot = document.createElement('div');
		modalRoot.setAttribute('id', 'modal');
		document.body.appendChild(modalRoot);
	}

	const modalElement = document.createElement('div');

	useEffect((): any => {
		modalRoot?.appendChild(modalElement);
		return () => modalRoot?.removeChild(modalElement);
	});

	return createPortal(children, modalElement);
};

export default Portal;
